export enum ProgressiveJackpotsEvent {
  PJ_CTA_MORE_INFO_CLICK = 'ProgressiveJackpotsCtaMoreInfoClick',
  PJ_CTA_PLAY_NOW_CLICK = 'ProgressiveJackpotsCtaPlayNowClick',
}
export enum FixedJackpotsEvent {
  FJ_CTA_MORE_INFO_CLICK = 'ProgressiveJackpotsCtaMoreInfoClick',
}
